import { useEffect, useState } from "react"
import { Form, Modal, Select } from "antd"
import CustomButton from "../../../components/CustomButton"
import CustomInput from "../../../components/CustomInput"
import CustomSelect from "../../../components/CustomSelect"
import Notifications from "../../../helpers/Notifications"
import { useTranslation } from "react-i18next"
import { useDebounce } from "use-debounce"
import { createAction, getListAction, updateAction } from "./store/actions"
import { reMeasurementUnitActions } from "../ReMeasurementUnit/store/actions"
import { useDispatch, useSelector } from "react-redux"

const RePTMsChangeForm = ({ visible, setVisible, setRecord, record }) => {
	const [parentPTM, setParentPTM] = useState(null)
	const [searchPTMs, setSearchPTMs] = useState('')
	const [searchMeasures, setSearchMeasures] = useState('')

	const { isLoading, list: PTMs } = useSelector(state => state.rePtmReducer)
	const { list: measures } = useSelector(state => state.reMeasurementUnitReducer)
	const [PTM] = useDebounce(searchPTMs, 500)
	const [measure] = useDebounce(searchMeasures, 500)

	const { t } = useTranslation(['common', 'valid', 'action'])
	const [form] = Form.useForm()
	const dispatch = useDispatch()

	const getReMeasureUnits = (values) => {
		dispatch(reMeasurementUnitActions.getList(values))
	}

	useEffect(() => {
		form.resetFields()
		if (record) {
			const parentPTM = PTMs.find(p => p.id == record.parent.id)
			setParentPTM(parentPTM)

			if (record.reMeasurementUnit.id != null && !measures.find(r => r.id == record.reMeasurementUnit.id)) {
				measures.push(record.reMeasurementUnit)
			}

			form.setFieldsValue({
				parent: parentPTM?.id,
				code: record.code,
				name: record.name,
				reMeasurementUnit: record.reMeasurementUnit.id,
			})
		}
		else
			setParentPTM(null)
	}, [record])

	useEffect(() => {
		dispatch(getListAction({ name: PTM?.trim() }))
	}, [PTM])

	useEffect(() => {
		getReMeasureUnits({ name: measure?.trim() })
	}, [measure])

	const handleCancel = () => {
		form.resetFields()
		setRecord(null)
		setVisible(false)
		setParentPTM(null)
	}

	const save = () => {
		form.validateFields().then(values => {
			const updateValues = {
				id: record?.id,
				parentId: values?.parent,
				code: values.code,
				name: values.name,
				reMeasurementUnitId: values?.reMeasurementUnit,
			}
			const previousValues = {
				id: record?.id,
				parentId: record?.parent.id,
				code: record?.code,
				name: record?.name,
				reMeasurementUnitId: record?.reMeasurementUnit.id,
			}
			if (JSON.stringify(updateValues) === JSON.stringify(previousValues))
				Notifications.errorNotice(t('valid:sameData'), null, 20)
			else
				record ? dispatch(updateAction(updateValues)) : dispatch(createAction(updateValues))
		})
	}

	const changeParentPtm = (ptmId) => {
		const parent = PTMs.find(p => p.id == ptmId)
		setParentPTM(parent)
		form.setFieldsValue({
			code: `${parent.code}-`,
		})
	}

	return (
		<Modal
			destroyOnHidden
			footer={[
				<CustomButton
					key="save"
					loading={isLoading}
					type="green"
					onClick={save}
				>
					{t('action:save')}
				</CustomButton>
			]}
			title={record ? t('action:editRecord') : t('action:addRecord')}
			open={visible}
			width={900}
			onCancel={handleCancel}
		>
			<Form
				form={form}
				labelAlign="left"
				labelCol={{ span: 6 }}
				name="nsi-form"
				wrapperCol={{ span: 17, offset: 1 }}
			>
				<Form.Item
					label={t('common:ptm')}
					name="parent"
				>
					<CustomSelect
						allowClear
						showSearch
						filterOption={false}
						notFoundContent={null}
						placeholder={`${t('action:choose')} ${t('common:ptm').toLowerCase()}`}
						onSearch={(e) => setSearchPTMs(e)}
						onChange={changeParentPtm}
					>
						{PTMs?.map(item => {
							return (
								<Select.Option
									key={item.id}
									value={item.id}
								>
									{`${item.code} ${item.name}`}
								</Select.Option>)
						})}
					</CustomSelect>
				</Form.Item>
				<Form.Item
					label={t('common:code')}
					name="code"
					extra={`Уровень ${(parentPTM?.level ?? 0) + 1}`}
					rules={[
						{
							required: true,
							message: t('valid:codeFilledBad'),
							pattern: /^(\d{1,2}\-){0,}(\d{1,2}){1}$/
						}
					]}
				>
					<CustomInput
						placeholder={`${t('action:enter')} ${t('common:code').toLowerCase()}`}
					/>
				</Form.Item>
				<Form.Item
					label={t('common:title')}
					name="name"
					rules={[
						{
							required: true,
							whitespace: true,
							min: 3,
							max: 200
						}
					]}
				>
					<CustomInput
						maxLength={250}
						placeholder={`${t('action:enter')} ${t('common:title').toLowerCase()}`}
					/>
				</Form.Item>
				<Form.Item
					label={t('common:measure')}
					name="reMeasurementUnit"
				>
					<CustomSelect
						allowClear
						showSearch
						filterOption={false}
						notFoundContent={null}
						placeholder={`${t('action:choose')} ${t('common:measure').toLowerCase()}`}
						onSearch={(e) => setSearchMeasures(e)}
					>
						{measures?.map(item => {
							return (
								<Select.Option
									key={item.id}
									value={item.id}
								>
									{item.name}
								</Select.Option>)
						})}
					</CustomSelect>
				</Form.Item>
			</Form>
		</Modal>
	)
}

export default RePTMsChangeForm
